// extracted by mini-css-extract-plugin
export default {"contactModalHeader":"styles_contactModalHeader__bzu-5","heading":"styles_heading__7EOkp"};